import { Module, ModuleLoader, ModulesToLoaders } from '../types';

/**
 * {@link https://app.getguru.com/card/ckKonEqi/Lazyloaded-modules-with-mewsmodules}
 */
const createModuleLoader = <M extends Module = Module, Deps extends Module[] = []>({
    name,
    load,
    dependencies,
}: {
    name: string;
    load(): Promise<{ createModule(deps: Deps): M }>;
    dependencies: ModulesToLoaders<Deps>;
}): ModuleLoader<M, Deps> => ({
    load,
    dependencies,
    toString: () => name,
});

export default createModuleLoader;
